export const DEVELOPMENT_LOGIN = "http://localhost:5173/login";
export const PRODUCTION_LOGIN = "https://accounts.abss.ai/login";
export const DEVELOPMENT_REGISTER = "http://localhost:5173/register";
export const PRODUCTION_REGISTER = "https://accounts.abss.ai/register";
export const DEVELOPMENT_MY_ACCOUNT =
  "http://localhost:5173/preferences?tab=profile";
export const PRODUCTION_MY_ACCOUNT =
  "https://accounts.abss.ai/preferences?tab=profile";
export const DEVELOPMENT_ACCOUNTS_API = "http://localhost:8080/api/v1";
export const PRODUCTION_ACCOUNTS_API = "https://api.accounts.abss.ai/api/v1";
export const DEVELOPMENT_ACCOUNT_DASHBOARD = "http://localhost:5173";
export const PRODUCTION_ACCOUNT_DASHBOARD = "https://accounts.abss.ai";
export const DEVELOPMENT_BOOKS_APP = "http://localhost:3000";
export const PRODUCTION_BOOKS_APP = "https://books.abss.ai";
export const DEVELOPMENT_CRM_APP = "http://localhost:5174";
export const PRODUCTION_CRM_APP = "https://crm.abss.ai";

const isDevelopment = process.env.NODE_ENV === "development";

export const LOGIN_URL = isDevelopment ? DEVELOPMENT_LOGIN : PRODUCTION_LOGIN;
export const REGISTER_URL = isDevelopment
  ? DEVELOPMENT_REGISTER
  : PRODUCTION_REGISTER;
export const MY_ACCOUNT_URL = isDevelopment
  ? DEVELOPMENT_MY_ACCOUNT
  : PRODUCTION_MY_ACCOUNT;
export const ACCOUNTS_API_URL = isDevelopment
  ? DEVELOPMENT_ACCOUNTS_API
  : PRODUCTION_ACCOUNTS_API;

// Account dashboard - the signed-in landing page listing every app.
export const ACCOUNT_DASHBOARD_URL = isDevelopment
  ? DEVELOPMENT_ACCOUNT_DASHBOARD
  : PRODUCTION_ACCOUNT_DASHBOARD;

// Keyed by the `module` value the accounts API returns for each app.
export const APP_URLS = {
  BOOKS: isDevelopment ? DEVELOPMENT_BOOKS_APP : PRODUCTION_BOOKS_APP,
  CRM: isDevelopment ? DEVELOPMENT_CRM_APP : PRODUCTION_CRM_APP,
};
